import Vue from 'vue'
import App from './App.vue'
import VueIntercom from '@mathieustan/vue-intercom'

import '@/modules/plugins'
import '@/modules/directives'
import '@/modules/mixins/global'
import intercom from '@/modules/mixins/intercom'

import router from '@/modules/router'
import store from '@/modules/store'

import '@/assets/style/main.scss'

Vue.config.productionTip = false

Vue.prototype.$cardPayment = 'stripe'
Vue.prototype.$user.initialize()

store.dispatch('site/getConfig').then(async (config) => {
    if (process.env.NODE_ENV === 'production') {
        if (config.intercom_appid) {
            Vue.use(VueIntercom, { appId: config.intercom_appid })
        }
    }
    new Vue({
        router,
        store,
        mixins: [intercom],
        mounted() {
            this.boot()
        },
        render: (h) => h(App),
    }).$mount('#app')
})
